<template>
  <div class="p-grid p-col-12" v-if="client.id">
    <div class="p-col-12">
      <page-header :dynamic-title="client.name">
        <ancestryline-tab class="float-left" :tabs="tabs"/>
      </page-header>
    </div>

    <h2 class="p-col-12">
      <strong>{{client.name}}</strong>
      <a class="cursor-pointer" :href="`#/client/${client.id}`"><i class="p-ml-2 pi pi-pencil" :title="$t('client.edit')"/></a>
      <hr/>
    </h2>

    <component :key="currentTab" :is="getComponent" :client="client"/>
  </div>
</template>

<script>
import AncestrylineTab from "@/components/tab/AncestrylineTab";
import EventBus from "@/commons/EventBus";
import ClientDetails from "@/viewer/client/tabs/ClientDetails";
import ClientBusiness from "@/business/ClientBusiness";
import DateUtils from "@/utils/DateUtils";
import PageHeader from "@/components/page/PageHeader";
import ClientProtocols from "@/viewer/client/tabs/ClientProtocols";
export default {
  name: "Client",
  components: {PageHeader, AncestrylineTab},

  async mounted(){
    const id = this.$route.params.id;
    if(id){
      EventBus.loadingPage(true);
      const client =  {... await ClientBusiness.getById(id)};
      client.birthDay = DateUtils.toStringDate(client.birthDay);
      if(client.deathDay) client.deathDay = DateUtils.toStringDate(client.deathDay);
      if(client.marriedDay) client.marriedDay = DateUtils.toStringDate(client.marriedDay);
      if(!client.address) client.address = {};
      this.client = this.initializeWeddingDates(client);
      EventBus.loadingPage(false);
    }
  },

  computed: {
    getComponent(){
      switch (this.currentTab){
        case 'protocols': return ClientProtocols;
        default: return ClientDetails;
      }
    },
    tabs(){
      return [
        {
          label: this.$t('client.tabs.general'),
          to: `/client/${this.client.id}/details`
        },
        {
          label: this.$t('client.tabs.protocols'),
          to: `/client/${this.client.id}/protocols`
        },
      ]
    },
    currentTab(){
      return this.$route.params.tab || 'general';
    }
  },

  data(){
    return {
      loading: true,
      client: {type: Object, default: {}},
    }
  },

    methods: {
        initializeWeddingDates(client) {
            client.spouses.forEach(wedding => {
                wedding.date = DateUtils.toStringDate(wedding.date);
            });
            return client;
        },
    }

}
</script>

<style scoped>

</style>